import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export interface DropZoneProps {
  onFiles: (files: File[]) => void;
  children?: React.ReactNode;
}

export function DropZone({ onFiles, children }: DropZoneProps) {
  const [dragging, setDragging] = useState(false);
  return (
    <Box
      onDragOver={(e) => { e.preventDefault(); if (!dragging) setDragging(true); }}
      onDragLeave={(e) => {
        e.preventDefault();
        // Ignore dragleave fired when moving onto a child node — only clear
        // when the pointer actually leaves the container.
        if (e.currentTarget.contains(e.relatedTarget as Node | null)) return;
        setDragging(false);
      }}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        const files = Array.from(e.dataTransfer?.files ?? []);
        if (files.length) onFiles(files);
      }}
      sx={{ position: "relative", width: "100%" }}
    >
      {children}
      {dragging && (
        <Box aria-hidden sx={(theme) => ({ position: "absolute", inset: 0, zIndex: 5, display: "grid", placeItems: "center", borderRadius: 1, border: `2px dashed ${alpha(theme.palette.primary.main, 0.6)}`, bgcolor: alpha(theme.palette.primary.main, 0.08), pointerEvents: "none" })}>
          <Typography variant="body2" sx={{ color: "primary.main", fontWeight: 600 }}>Drop files to attach</Typography>
        </Box>
      )}
    </Box>
  );
}
